(function(){
  var el=document.getElementById('mcsim'); if(!el) return;
  var MIN=parseInt(el.getAttribute('data-min'),10); if(!(MIN>0)) MIN=2;
  var FALLBACK=el.getAttribute('data-fallback')||'celular';
  var MINI=el.getAttribute('data-mini')||'';
  var AGR=el.getAttribute('data-agregar')||'';
  // 2026-08-04 · La categoria que se muestra aqui es un AJUSTE, no una constante: por
  // defecto 'funda' (ver cabecera de la seccion). Se compara contra la categoria del
  // producto actual solo para decidir cual de los dos titulos se pinta.
  var OBJ_AJUSTE=(el.getAttribute('data-objetivo')||'funda').trim()||'funda';
  var T_ALT=el.getAttribute('data-titulo-alt')||'';
  var T_COMP=el.getAttribute('data-titulo-comp')||'';
  var S_ALT=el.getAttribute('data-sub-alt')||'';
  var S_COMP=el.getAttribute('data-sub-comp')||'';
  function go(){
    var combo=document.getElementById('mccombo');
    if(!combo){ return; }
    var sid=combo.getAttribute('data-sid'), pid=combo.getAttribute('data-pid'), cur=combo.getAttribute('data-curcat')||'otro';
    // 'misma' = el comportamiento anterior al 2026-08-04: se refleja la categoria del
    // producto que se esta viendo. Cualquier otro valor es una categoria fija.
    var OBJETIVO=(OBJ_AJUSTE==='misma')?cur:OBJ_AJUSTE;
    // EXCEPCION DE LOS ACCESORIOS (2026-08-04). Los 17 'cat:accesorio' son pulseras de
    // MI Band, correas de MI Watch y estuches de audifonos: quien los mira esta en una
    // mision distinta de quien compra proteccion de celular. Ofrecerle ahi una funda es
    // un salto de contexto, y ademas el titulo quedaria raro ("Fundas para tu Redmi
    // Note 14" al pie de una pulsera de reloj). Esos productos SI tienen alternativas
    // reales entre ellos -otros colores, otros materiales-, asi que conservan el
    // comportamiento de alternativa. Es coherente con micase-combo, que descarta los
    // accesorios de su cross-selling por la misma razon ("no completan la compra").
    if(cur==='accesorio') OBJETIVO='accesorio';
    // 2026-07-30 · MANDA LA VARIANTE DE LA PAGINA, NO EL QUIZ.
    // ERROR QUE CORRIGE: el titulo decia "Otras opciones para tu Xiaomi 17 Pro"
    // mientras la pagina estaba en Xiaomi 17T Pro, y peor, TRAIA los productos del
    // modelo equivocado. La causa: se leia primero localStorage.micase_modelo (lo
    // que la persona respondio en el quiz, tal vez dias antes) y ese valor ganaba
    // sobre la variante seleccionada. micase-combo ya habia corregido esto el
    // 2026-07-28 con la nota "LA VARIANTE MANDA"; aqui se habia quedado la version
    // vieja, y por eso las dos secciones se contradecian.
    // Ahora el orden es: 1) el nombre que micase-combo ya pinta en #mccombo-model,
    // que es la variante viva; 2) el selector del producto; 3) el quiz, solo si no
    // hay nada seleccionado. Tomando el nombre del mismo nodo que usa el combo, las
    // dos secciones NO PUEDEN desalinearse: leen la misma fuente.
    // La logica canonica vive en snippets/micase-modelo.liquid (window.MCModelo).
    function alHandle(v){
      if(window.MCModelo && window.MCModelo.handle) return window.MCModelo.handle(v);
      /* respaldo: misma logica, por si el snippet no cargo. El + pasa a la palabra plus
         ANTES de limpiar; sin eso "Pro + (5G)" y "Pro (5G)" quedan identicos. */
      return String(v||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'')
        .replace(/\+/g,' plus ').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
    }
    var name=((document.getElementById('mccombo-model')||{}).textContent||'').trim();
    var handle=name?alHandle(name):null;
    if(!handle){
      var pj=document.querySelector('[data-product-json]');
      var p=null; if(pj){ try{p=JSON.parse(pj.textContent)}catch(e){p=null} }
      if(p){
        var idx=-1;(p.options||[]).forEach(function(o,i){if(idx<0&&/modelo/i.test(String(o)))idx=i});
        if(idx<0&&p.options&&p.options.length===1)idx=0;
        if(idx>=0){
          var optName=p.options[idx];
          var r=document.querySelector('input[type=radio][name="'+(window.CSS&&CSS.escape?CSS.escape(optName):optName)+'"]:checked');
          var val=r?r.value:null;
          if(!val){ var v=null,i; for(i=0;i<(p.variants||[]).length;i++){ if(p.variants[i].available){v=p.variants[i];break} } v=v||(p.variants&&p.variants[0]); val=v?v.options[idx]:null; }
          if(val){ name=val; handle=alHandle(val); }
        }
      }
    }
    if(!handle){
      try{ var q=JSON.parse(localStorage.getItem('micase_modelo')||'null'); if(q&&q.h){ handle=q.h; name=name||q.n; } }catch(e){ console.warn('[MIcase] micase-similares: no se pudo leer el JSON del modelo guardado en localStorage', e); }
    }
    if(!handle) return;
    // 2026-07-30 · PRIMERO SE MIRA SI micase-combo YA LO PIDIO.
    // Esta seccion pedia byte a byte la misma URL que el combo acababa de pedir,
    // solo para leer #mccombo-items y filtrar por data-cat. Ahora el combo publica
    // su respuesta en window.__mcComboItems y avisa con el evento
    // 'micase:combo-items'. Si el combo esta apagado o tarda, a los 2,5 segundos
    // esta seccion pide por su cuenta: nunca queda dependiendo de la otra.
    var cache=null;
    try{ cache=window.__mcComboItems }catch(e){ console.warn('[MIcase] micase-similares: no se pudieron leer las tarjetas que publico micase-combo', e); }
    if(cache && cache.handle===handle && cache.html){ pintar(cache.html); return }
    var resuelto=false;
    function alLlegar(ev){
      if(resuelto || !ev.detail || ev.detail.handle!==handle) return;
      resuelto=true;
      document.removeEventListener('micase:combo-items',alLlegar);
      pintar(ev.detail.html);
    }
    document.addEventListener('micase:combo-items',alLlegar);
    setTimeout(function(){
      if(resuelto) return;
      resuelto=true;
      document.removeEventListener('micase:combo-items',alLlegar);
      pedir();
    },2500);

    function pedir(){
    /* MIcase 2026-08-20 · LA RUTA LA DECIDE EL DICCIONARIO, NO ESTE ARCHIVO.
       El nombre del desplegable no siempre es una etiqueta con productos detras
       ("Redmi Note 10 / 10s" la lleva 1 producto; "Redmi Note 10", 13). El desvio
       vive en el metaobjeto micase_modelo y lo publica snippets/micase-modelo.liquid.
       Si no cargara, rutaDe devuelve lo mismo que le dan y esto se comporta como antes. */
    var mcRuta = (window.MCModelo && MCModelo.rutaDe) ? MCModelo.rutaDe(handle) : handle;
    /* 2026-08-20 · LA VISTA PREVIA TIENE QUE PODER PROBARSE. Esta llamada no decia de
       que tema se sirve la pagina, asi que en una vista previa iba a buscar los
       productos al tema PUBLICADO y era imposible verificar un cambio sin publicarlo.
       En la tienda normal el rol es 'main' y esto no anade nada. */
    var previa = '';
    try {
      if (window.Shopify && Shopify.theme && Shopify.theme.id &&
          String(Shopify.theme.role || '').toLowerCase() !== 'main') {
        previa = '&preview_theme_id=' + Shopify.theme.id;
      }
    } catch (e) {}
    fetch('/collections/all/'+mcRuta+'?sort_by=best-selling&section_id='+sid+previa)
      .then(function(r){return r.text()})
      .then(pintar).catch(function(e){ console.warn('[MIcase] micase-similares: fallo al pedir a la coleccion los productos similares', e); });
    }
    function pintar(html){
        var d=document.createElement('div'); d.innerHTML=html;
        var items=d.querySelector('#mccombo-items'); if(!items) return;
        var arr=Array.prototype.slice.call(items.children).filter(function(n){
          if(n.getAttribute('data-pid')===pid) return false;
          if((n.getAttribute('data-cat')||'otro')!==OBJETIVO) return false;
          // 2026-08-18 (noche) · SOLO ENTRA LO QUE SE PUEDE COMPRAR HOY PARA ESTE MODELO.
          // Sebastian, sobre una captura: "aparece en una de las fichas 'Ver'. En teoria
          // solamente ibamos a colocar 'Agregar'". Tenia razon y el motivo no era de codigo:
          // era INVENTARIO. micase-combo solo emite formulario cuando encuentra una variante
          // del modelo DISPONIBLE (sections/micase-combo.liquid, la condicion v.available);
          // si no, cae a un enlace a la ficha. El caso real: Case MagSafe Matte Antigolpes
          // tiene Xiaomi 15 en Negro y en Blanco, las dos en CERO. Verificado por API.
          // Y no era solo el boton: sin variante, el precio cae al minimo de TODA la
          // publicacion, asi que la tarjeta decia "Desde $44.900" cuando el Xiaomi 15 vale
          // $54.900. Un precio que no es y un boton que no agrega, en la zona cuyo unico
          // trabajo es que agreguen.
          // La decision: no se ofrece lo que no se puede comprar. Si eso deja la zona por
          // debajo del minimo, la zona no aparece, que es mejor que un callejon sin salida.
          return !!n.querySelector('.mccombo__f input[name="id"]');
        }).slice(0,Math.max(3,MIN));
        if(arr.length<MIN){ el.hidden=true; return; }
        // El titulo depende de si lo que se muestra es una ALTERNATIVA a lo que se esta
        // mirando (misma categoria) o un COMPLEMENTO (categoria distinta). Si el ajuste
        // del titulo de complemento esta vacio se usa el de alternativa: nunca se queda
        // sin encabezado.
        var esAlt=(cur===OBJETIVO);
        var h=document.getElementById('mcsim-h'), sub=document.getElementById('mcsim-sub');
        if(h){
          var txt=esAlt?T_ALT:(T_COMP||T_ALT);
          h.firstChild ? (h.firstChild.nodeValue=txt+' ') : (h.textContent=txt+' ');
        }
        if(sub){
          var stxt=esAlt?S_ALT:(S_COMP||S_ALT);
          sub.textContent=stxt;
          sub.hidden=!stxt;
        }
        document.getElementById('mcsim-model').textContent=name||FALLBACK;
        var list=document.getElementById('mcsim-list'); list.innerHTML='';
        arr.forEach(function(n){
          // 2026-08-18 · AQUI SE SUSTITUIA EL FORMULARIO DE ANADIR AL CARRITO POR UN ENLACE
          // A LA FICHA, etiquetado "Ver". Era el freno mas caro de esta zona: obligaba a un
          // viaje a otra pagina para algo que cabe en un clic, y esta zona paso a ser una de
          // las superficies que empujan la segunda funda. Ahora el formulario que emite el
          // combo se conserva TAL CUAL LLEGA -es el mismo que ya funciona en el combo de
          // arriba, asi que no hay codigo nuevo de carrito que pueda fallar- y solo se le
          // cambia la etiqueta del boton.
          // NO SE TOCA EL TEXTO DESPUES DE AGREGAR: de eso se encarga micase-popups.js, que
          // deja el boton en "Agregando…" mientras dura la peticion y luego lo devuelve.
          var b=n.querySelector('.mccombo__f button');
          if(b&&AGR) b.textContent=AGR;
          // El modelo, repetido en cada tarjeta. Es lo unico que separa esto de un catalogo
          // generico y hasta hoy aparecia una sola vez, en el titulo de la seccion.
          if(MINI){
            var pn=n.querySelector('.mccombo__p');
            if(pn&&!n.querySelector('.mcsim__mini')){
              var mi=document.createElement('p'); mi.className='mcsim__mini';
              mi.textContent=String(MINI).split('[modelo]').join(name||FALLBACK);
              pn.parentNode.insertBefore(mi,pn.nextSibling);
            }
          }
          list.appendChild(n);
        });
        el.hidden=false;
    }
  }
  // Si la persona cambia de modelo sin recargar, micase-combo repinta
  // #mccombo-model. Se vigila ese nodo y se vuelve a pedir la lista: si no, esta
  // seccion se queda con los productos del modelo anterior, que es otra forma del
  // mismo error de desalineacion.
  var ultimo='';
  function goSiCambio(){
    var n=((document.getElementById('mccombo-model')||{}).textContent||'').trim();
    if(n===ultimo) return;
    ultimo=n; go();
  }
  function init(){
    var t=0; var iv=setInterval(function(){ t++;
      var c=document.getElementById('mccombo');
      if((c&&c.getAttribute('data-sid'))||t>40){
        clearInterval(iv);
        if(!c) return;
        goSiCambio();
        var m=document.getElementById('mccombo-model');
        if(m&&window.MutationObserver){ new MutationObserver(goSiCambio).observe(m,{childList:true,characterData:true,subtree:true}) }
      } },150);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();